import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdEmail, MdArrowBack } from "react-icons/md";
import { authApi } from "../api/authApi";
import { toast } from "react-toastify";
import { CyberRiskLogo360 } from "../assets/image";

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await authApi.forgotPassword(email);
      setSent(true);
      toast.success(response.message || "Password reset link sent to your email");
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to send reset link";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img
              src={CyberRiskLogo360}
              alt="CyberRisk Logo"
              loading="lazy"
              style={{height:"100px", width:"170px"}}
              className="mb-0"
            />
            <h1 className="login-title">Check Your Email</h1>
            <p className="login-subtitle">
              We've sent a password reset link to {email}
            </p>
          </div>

          <button onClick={onBackToLogin} className="back-to-login-btn">
            <MdArrowBack />
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src={CyberRiskLogo360}
            alt="CyberRisk Logo"
            className="login-logo"
          />
          <h1 className="login-title">Forgot Password</h1>
          <p className="login-subtitle">
            Enter your email to reset your password
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-wrapper">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            {error && (
              <div style={{ color: '#dc2626', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                {error}
              </div>
            )}
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <button
            type="button"
            onClick={onBackToLogin}
            className="back-to-login-btn"
          >
            <MdArrowBack />
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
